<template>
  <div
    class="pb-12 max-w-lg mx-auto"
  >
    <h2>Assessor {{ assessor.assessor_id }}</h2>
    <template v-if="assessor.interview_feedback">
      <h3 class="mt-4 mb-2">
        Interview Feedback
      </h3>
      <div
        class="italic leading-loose"
        v-html="parseMarkdown(assessor.interview_feedback || '')"
      />
      <h3 class="mt-4 mb-2">
        Application Feedback
      </h3>
    </template>
    <div
      class="italic leading-loose"
      v-html="parseMarkdown(assessor.comments || '')"
    />
  </div>
</template>

<script>
export default {
  name: 'AssessorFeedbackSingle',
  props: {
    assessor : {
      type: Object,
      required: true
    }
  }
}
</script>